import { z } from 'zod';

export const validationSchema = z.object({
  password: z.string().min(8, {
    message: 'i18n.profile.updatePassword.form.password.error|{"min": 8}',
  }),
});

export type FormValues = z.infer<typeof validationSchema>;

export const defaultValues: FormValues = {
  password: '',
};
